export default defineNuxtRouteMiddleware((to) => {
  if (to.meta.hasSubmenu === false) {
    setSubmenuVisibility(false)
  }
})
